import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'ws-ace-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
    standalone: false
})
export class AceCardComponent implements OnInit {
    /** ACE params */
    @Input() header: string;
    @Input() contentHeight: string;
    @Input()
    @HostBinding('style.width') width: string;
    @Input()
    @HostBinding('style.height') height: string;

    /** PP specific params */
    @Input() helpContentId: string;
    @Input() hasActions: boolean;

    hasTitlebar: boolean;
    styles: any;

    ngOnInit() {
        this.hasTitlebar = !!(this.header || this.helpContentId || this.hasActions);
    }
}
